'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react.production.min.js');
} else {
  module.exports = require('./cjs/react.development.js');
}
